import * as l from "../../../lib/littlejs.esm";
import { tilesize, tilesheets } from '../../const/tiles.ts';
/**
 * Base enemy class that provides common enemy functionality
 */
class Enemy extends l.EngineObject {
    /**
     * @param {l.Vector2} pos - Position of the enemy
     * @param {number} tileIndex - Tile index for the enemy sprite
     */
    constructor(pos, tileIndex) {
        super(pos, l.vec2(1, 1), l.tile(tileIndex, tilesize, tilesheets.ASSETS));
        this.setCollision(true, true, false, true);
        this.mass = 0; // Not affected by gravity
    }
    /**
     * Update method to be overridden by subclasses
     */
    update() {
        super.update();
    }
}
export default Enemy;
